<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"> </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      getUserToken: this.getUserToken,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      pageUrl: "",
    };
  },
  mounted() {
    this.userAgent = navigator.userAgent.toLowerCase();
    this.pageUrl = window.location.origin;
    window.onload = this.loadScript();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    //加载百度地图
    loadScript() {
      var script = document.createElement("script");
      script.src =
        "https://api.map.baidu.com/api?v=2.0&ak=ZZW5cGetFQ6AVKq2Iwg88DDmYadKUhBG&callback=initialize";
      document.body.appendChild(script);
    },
    //获取token
    getUserToken() {
      if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
        this.weixinLogin();
      } else {
        this.commonLogin();
      }
    },
    /*浏览器登录*/
    commonLogin() {
      this.$router.push({
        name: "login",
        params: {
          url: window.location.href,
        },
      });
    },
    /*微信登录*/
    weixinLogin() {
      let str = window.location.href;
      // let index = str.lastIndexOf("#");
      // let startUrl = str.substring(0, index);
      // let endUrl = str.substring(index + 2, str.length);
      // str = startUrl + "" + endUrl;
      var oauthUrl = escape(this.pageUrl + "/oauth?targetUrl=" + str);
      var reduri =
        "http://reg.chexun.com/weChatLogin.aspx?oauthUrl=" + oauthUrl;
      var threeHref =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9fb7f19e29f57706&scope=snsapi_userinfo&";
      threeHref +=
        "redirect_uri=" +
        reduri +
        "&state=100201&response_type=code#wechat_redirect";
      window.location.href = threeHref;
    },
  },
};
</script>

<style lang="scss">
body,
div,
ul,
ol,
li,
p,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
img,
form,
input,
button,
textarea,
th,
td,
figure,
figcaption {
  margin: 0;
  padding: 0;
}

ul,
ol {
  list-style: none;
}
body a {
  text-decoration: none;
}
img {
  display: block;
}
</style>
